import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const demoRoutes = []
if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_INCLUDE_DEMOS) {
  const vueBookRoutes = require('./vueBookRoutes').default
  vueBookRoutes.forEach(route => demoRoutes.push(route))
}

const router = new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: { name: 'dashboard' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          name: 'new-password',
          path: 'new-password',
          component: EmptyParentComponent,
          children: [
            {
              name: 'new-password-child',
              path: ':resetCode',
              component: () => import('../components/auth/new-password/NewPassword.vue'),
            },
          ],
        },
        {
          name: 'recover-password',
          path: 'recover-password',
          component: () => import('../components/auth/recover-password/RecoverPassword.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    {
      path: '/404',
      component: EmptyParentComponent,
      children: [
        {
          name: 'not-found-advanced',
          path: 'not-found-advanced',
          component: () => import('../components/pages/404-pages/VaPageNotFoundSearch.vue'),
        },
        {
          name: 'not-found-simple',
          path: 'not-found-simple',
          component: () => import('../components/pages/404-pages/VaPageNotFoundSimple.vue'),
        },
        {
          name: 'not-found-custom',
          path: 'not-found-custom',
          component: () => import('../components/pages/404-pages/VaPageNotFoundCustom.vue'),
        },
        {
          name: 'not-found-large-text',
          path: '/pages/not-found-large-text',
          component: () => import('../components/pages/404-pages/VaPageNotFoundLargeText.vue'),
        },
      ],
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
          children: [
            {
              name: 'dashboard_sites' /* _ separates sidebar name from rest in children. This allows VaSidebarLink to still determine the active one */,
              path: ':siteId',
              component: () => import('../components/dashboard/Dashboard.vue'),
              children: [
                {
                  name: 'dashboard_site-gws',
                  path: ':gwSerial',
                  component: () => import('../components/dashboard/Dashboard.vue'),
                  children: [
                    {
                      name: 'dashboard_site-gw-invs',
                      path: ':invSerial',
                      component: () => import('../components/dashboard/Dashboard.vue'),
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'alerts',
          path: '/alerts',
          component: () => import('../components/alerts/Alerts.vue'),
          // default: true,
          // children: [
          //   {
          //     name: 'dashboard_sites', /* _ separates sidebar name from rest in children. This allows VaSidebarLink to still determine the active one */
          //     path: ':siteId',
          //     component: () => import('../components/dashboard/Dashboard.vue'),
          //     children: [
          //       {
          //         name: 'dashboard_site-gws',
          //         path: ':gwSerial',
          //         component: () => import('../components/dashboard/Dashboard.vue'),
          //         children: [
          //           {
          //             name: 'dashboard_site-gw-invs',
          //             path: ':invSerial',
          //             component: () => import('../components/dashboard/Dashboard.vue'),
          //           },
          //         ],
          //       },
          //     ],
          //   },
          // ],
        },
        {
          name: 'reports',
          path: 'reports',
          component: EmptyParentComponent,
          children: [
            {
              name: 'reports-site-prod',
              path: 'reports-site-prod',
              component: () => import('../components/reports/Main.vue'),
            },
            {
              name: 'reports-inverter-prod',
              path: 'reports-inverter-prod',
              component: () => import('../components/reports/Main.vue'),
            },
          ],
        },

        {
          name: 'admin',
          path: 'admin',
          component: EmptyParentComponent,
          children: [
            {
              name: 'admin-users',
              path: 'users',
              component: () => import('../components/users/Users.vue'),
            },
            {
              name: 'admin-accounts',
              path: 'accounts',
              component: () => import('../components/users/Accounts.vue'),
            },
            {
              name: 'admin-sites',
              path: 'sites',
              component: () => import('../components/users/Sites.vue'),
            },
            {
              name: 'admin-gateways',
              path: 'gateways',
              component: () => import('../components/users/Gateways.vue'),
            },
          ],
        },
      ],
    },
  ],
})

router.afterEach((to, from) => {
  Vue.prototype.$mixpanel.track('Page Viewed', {
    'Page Title': to.name,
    URL: to.path,
    email: Vue.cookie.get('qemail'),
  })
})
export default router
